import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTeam } from '../contexts/TeamContext';

interface ProtectedRouteProps {
	children: React.ReactNode;
	adminOnly?: boolean;
}

export function ProtectedRoute({ children, adminOnly }: ProtectedRouteProps) {
	const { isAuthenticated, isLoading } = useAuth();
	const { currentTeam, isLoading: teamLoading } = useTeam();
	const location = useLocation();

	if (isLoading || (adminOnly && teamLoading)) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (adminOnly && currentTeam?.role === 'member') {
		return <Navigate to="/chat" replace />;
	}

	return <>{children}</>;
}
